import React from "react"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router"
import { Provider } from "react-redux"
import store from "./store"
import { createRoot } from 'react-dom/client';
import { getAllAddress } from "./helpers/address";

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
)

const container = document.getElementById('root');
const root = createRoot(container);
root.render(app);
serviceWorker.unregister()

// Tải sẵn dữ liệu địa chỉ ngay khi vào admin (không chặn render)
getAllAddress().catch(() => { });
